import { DynamicLayoutBlocks, PreviewThemeColors } from '@MerchantConfigurator/constants';
import {
  minimumBannerContainerWidth,
  minimumUpstreamMessageWidth,
  mobileContainerWidth,
  previewSectionSizes
} from '@MerchantConfigurator/constants/previewSectionStyles';
import {
  closeIconRow,
  getBackgroundColor,
  getContainer,
  getEstimatedTotalLine,
  getHorizontalBars,
  getProductWithOneDescription,
  getProductWithTwoDescriptions,
  horizontalLine
} from '@MerchantConfigurator/utils/CommonPreviewBlocks';
import {
  getMobileButton,
  getMobileMainContainer,
  getMobilePreviewButton,
  getMobilePreviewHeader,
  getMobileProductPreviewHeader,
  getMobileTextField,
  getPreviewBlocks
} from '@MerchantConfigurator/utils/MobilePreviewBlocks';

export const mobileLayouts = {
  getCartPage: ({ darkMode = false }) => {
    return {
      ...getMobileMainContainer({ darkMode }),
      blocks: [
        getMobilePreviewHeader({ darkMode }),
        {
          //right panel
          ...getContainer({
            style: {
              width: previewSectionSizes['17xl'],
              flexDirection: 'column',
              alignItems: 'start',
              justifyContent: 'start',
              paddingLeft: previewSectionSizes['xl'],
              backgroundColor: darkMode
                ? PreviewThemeColors.dark.backgroundMainColor
                : PreviewThemeColors.light.backgroundMainColor
            }
          }),
          blocks: [
            {
              ...getContainer({
                style: {
                  width: mobileContainerWidth,
                  flexDirection: 'column',
                  alignItems: 'start',
                  justifyContent: 'start',
                  backgroundColor: darkMode
                    ? PreviewThemeColors.dark.backgroundMainColor
                    : PreviewThemeColors.light.backgroundMainColor,
                  marginTop: previewSectionSizes.md
                }
              }),
              blocks: getPreviewBlocks({
                darkMode,
                message: 'preview.button.checkout'
              })
            }
          ]
        }
      ]
    };
  },
  getProductPage: ({ darkMode = false }) => {
    return {
      ...getMobileMainContainer({ darkMode }),
      blocks: [
        getMobilePreviewHeader({ darkMode }),
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              height: previewSectionSizes['10xl'],
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'componentsColor'
              }),
              marginTop: previewSectionSizes['2xl'],
              marginBottom: previewSectionSizes['2xl']
            }
          })
        },
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              flexDirection: 'column',
              gap: previewSectionSizes.sm,
              alignItems: 'flex-start'
            }
          }),
          blocks: [
            //product name bar
            ...getHorizontalBars({
              style: {
                width: previewSectionSizes['4xl'],
                height: previewSectionSizes.sm,
                backgroundColor: getBackgroundColor({
                  darkMode,
                  backgroundColor: 'componentsColor'
                })
              },
              number: 1
            }),
            //product price bar
            ...getHorizontalBars({
              style: {
                width: previewSectionSizes['2xl'],
                height: previewSectionSizes.sm,
                backgroundColor: getBackgroundColor({
                  darkMode,
                  backgroundColor: 'componentsColor'
                })
              },
              number: 1
            })
          ]
        },
        //upstream message
        {
          type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
          style: {
            width: minimumUpstreamMessageWidth,
            height: previewSectionSizes['6xl'],
            marginBottom: previewSectionSizes['3xl'],
            marginLeft: previewSectionSizes.sm,
            marginTop: previewSectionSizes.sm
          }
        },
        getMobileButton({ darkMode, message: 'preview.addToCart' })
      ]
    };
  },
  getCheckoutPage: ({ darkMode = false }) => {
    return {
      ...getMobileMainContainer({ darkMode }),
      blocks: [
        // header section
        getMobilePreviewHeader({ darkMode }),
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              justifyContent: 'start',
              marginTop: previewSectionSizes['2xl']
            }
          }),
          blocks: [
            //text field 1
            getMobileTextField({ darkMode })
          ]
        },
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              justifyContent: 'start',
              marginTop: previewSectionSizes.sm
            }
          }),
          blocks: [
            //text field 2
            getMobileTextField({ darkMode })
          ]
        },
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              justifyContent: 'start',
              marginTop: previewSectionSizes.sm
            }
          }),
          blocks: [
            //text field 3
            getMobileTextField({ darkMode })
          ]
        },
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              justifyContent: 'start',
              marginTop: previewSectionSizes.sm
            }
          }),
          blocks: [
            //text field 4
            getMobileTextField({ darkMode })
          ]
        },
        //right side details section
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              height: '34.4px',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'space-evenly',
              gap: previewSectionSizes.xs,
              marginTop: previewSectionSizes['2xl']
            }
          }),
          blocks: [
            //item 1
            {
              ...getContainer({
                style: {
                  height: previewSectionSizes.sm,
                  justifyContent: 'space-between',
                  gap: previewSectionSizes['6xl'],
                  overflow: 'hidden',
                  width: previewSectionSizes['14xl']
                }
              }),
              blocks: [
                ...getHorizontalBars({
                  style: {
                    width: previewSectionSizes['5xl'],
                    height: previewSectionSizes.sm,
                    backgroundColor: getBackgroundColor({
                      darkMode,
                      backgroundColor: 'componentsColor'
                    })
                  },
                  number: 1
                }),
                ...getHorizontalBars({
                  style: {
                    width: previewSectionSizes['2xl'],
                    height: previewSectionSizes.sm,
                    backgroundColor: getBackgroundColor({
                      darkMode,
                      backgroundColor: 'componentsColor'
                    })
                  },
                  number: 1
                })
              ]
            },
            //item 2
            {
              ...getContainer({
                style: {
                  height: previewSectionSizes.sm,
                  justifyContent: 'space-between',
                  gap: previewSectionSizes['6xl'],
                  overflow: 'hidden',
                  width: previewSectionSizes['14xl']
                }
              }),
              blocks: [
                ...getHorizontalBars({
                  style: {
                    width: previewSectionSizes['5xl'],
                    height: previewSectionSizes.sm,
                    backgroundColor: getBackgroundColor({
                      darkMode,
                      backgroundColor: 'componentsColor'
                    })
                  },
                  number: 1
                }),
                ...getHorizontalBars({
                  style: {
                    width: previewSectionSizes['2xl'],
                    height: previewSectionSizes.sm,
                    backgroundColor: getBackgroundColor({
                      darkMode,
                      backgroundColor: 'componentsColor'
                    })
                  },
                  number: 1
                })
              ]
            }
          ]
        },
        horizontalLine({
          darkMode,
          width: mobileContainerWidth,
          marginTop: previewSectionSizes.md
        }),
        //total
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              justifyContent: 'space-between',
              gap: previewSectionSizes.lg,
              paddingTop: previewSectionSizes.sm
            }
          }),
          blocks: [
            ...getEstimatedTotalLine({
              darkMode,
              barWidth: previewSectionSizes['2xl']
            })
          ]
        },
        //upstream message
        {
          type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
          style: {
            width: minimumUpstreamMessageWidth,
            height: previewSectionSizes['6xl'],
            marginTop: previewSectionSizes.sm,
            marginLeft: previewSectionSizes.sm,
            marginBottom: previewSectionSizes.md
          }
        },
        getMobileButton({ darkMode, message: 'preview.button.checkout' })
      ]
    };
  },
  getHomePage: ({ darkMode = false }) => {
    return {
      ...getMobileMainContainer({ darkMode }),
      blocks: [
        // header section
        getMobilePreviewHeader({ darkMode }),
        //upstream message
        {
          type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
          style: {
            height: previewSectionSizes['3xl'],
            width: minimumBannerContainerWidth,
            marginLeft: previewSectionSizes.sm,
            marginTop: previewSectionSizes.sm
          }
        },
        {
          ...getContainer({
            style: {
              justifyContent: 'start',
              width: previewSectionSizes['14xl']
            }
          }),
          blocks: getProductWithTwoDescriptions({ darkMode, number: 1 })
        },
        {
          ...getContainer({
            style: {
              justifyContent: 'start',
              width: previewSectionSizes['14xl']
            }
          }),
          blocks: getProductWithTwoDescriptions({ darkMode, number: 1 })
        }
      ]
    };
  },
  getCategoryPage: ({ darkMode = false }) => {
    return {
      ...getMobileMainContainer({ darkMode }),
      blocks: [
        // header section
        getMobilePreviewHeader({ darkMode }),
        //upstream message
        {
          type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
          style: {
            width: minimumBannerContainerWidth,
            height: previewSectionSizes['3xl'],
            marginLeft: previewSectionSizes.sm,
            marginTop: previewSectionSizes.sm
          }
        },
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['14xl'],
              flexDirection: 'row',
              justifyContent: 'start',
              alignItems: 'start'
            }
          }),
          blocks: [
            {
              ...getContainer({
                style: {
                  flexDirection: 'column',
                  alignItems: 'start',
                  marginTop: previewSectionSizes.xs,
                  marginRight: previewSectionSizes['2xl']
                }
              }),
              blocks: [...getProductWithOneDescription({ darkMode, number: 3 })]
            },
            {
              ...getContainer({
                style: {
                  flexDirection: 'column',
                  alignItems: 'start',
                  marginTop: previewSectionSizes.xs
                }
              }),
              blocks: [...getProductWithOneDescription({ darkMode, number: 3 })]
            }
          ]
        }
      ]
    };
  },
  getCartPreviewPage: ({ darkMode = false }) => {
    return {
      ...getMobileMainContainer({
        darkMode,
        lightBackgroundColor: PreviewThemeColors.light.backgroundAlternateColor
      }),
      blocks: [
        {
          //right panel
          ...getContainer({
            style: {
              width: '248px',
              height: '492px',
              flexDirection: 'column',
              alignItems: 'start',
              justifyContent: 'start',
              paddingLeft: previewSectionSizes.md,
              marginBottom: previewSectionSizes.md,
              backgroundColor: darkMode
                ? PreviewThemeColors.dark.backgroundAlternateColor
                : PreviewThemeColors.light.backgroundMainColor
            }
          }),
          blocks: [
            closeIconRow({
              style: {
                width: '232px',
                justifyContent: 'end',
                paddingTop: previewSectionSizes.sm,
                marginRight: previewSectionSizes.lg
              }
            }),
            ...getPreviewBlocks({
              darkMode,
              message: 'preview.button.checkout'
            })
          ]
        }
      ]
    };
  },
  getProductPreviewPage: ({ darkMode = false }) => {
    return {
      ...getMobileMainContainer({
        darkMode,
        lightBackgroundColor: PreviewThemeColors.light.backgroundAlternateColor
      }),
      blocks: [
        getMobileProductPreviewHeader({ darkMode }),
        {
          ...getContainer({
            style: {
              width: '248px',
              height: previewSectionSizes['12xl'],
              backgroundColor: darkMode
                ? PreviewThemeColors.dark.backgroundAlternateColor
                : PreviewThemeColors.light.backgroundMainColor
            }
          }),
          blocks: [
            getContainer({
              style: {
                width: previewSectionSizes['14xl'],
                height: previewSectionSizes['9xl'],
                backgroundColor: getBackgroundColor({
                  darkMode,
                  backgroundColor: 'componentsColor'
                })
              }
            })
          ]
        },
        {
          ...getContainer({
            style: {
              width: '248px',
              flexDirection: 'column',
              gap: previewSectionSizes.sm,
              alignItems: 'flex-start',
              backgroundColor: darkMode
                ? PreviewThemeColors.dark.backgroundAlternateColor
                : PreviewThemeColors.light.backgroundMainColor
            }
          }),
          blocks: [
            //product name bar
            ...getHorizontalBars({
              style: {
                width: previewSectionSizes['4xl'],
                height: previewSectionSizes.sm,
                marginLeft: previewSectionSizes.md,
                backgroundColor: getBackgroundColor({
                  darkMode,
                  backgroundColor: 'componentsColor'
                })
              },
              number: 1
            }),
            //product price bar
            ...getHorizontalBars({
              style: {
                width: previewSectionSizes['2xl'],
                height: previewSectionSizes.sm,
                marginLeft: previewSectionSizes.md,
                backgroundColor: getBackgroundColor({
                  darkMode,
                  backgroundColor: 'componentsColor'
                })
              },
              number: 1
            })
          ]
        },
        {
          ...getContainer({
            style: {
              width: previewSectionSizes['15xl'],
              flexDirection: 'column',
              alignItems: 'flex-start',
              paddingLeft: previewSectionSizes.md,
              backgroundColor: darkMode
                ? PreviewThemeColors.dark.backgroundAlternateColor
                : PreviewThemeColors.light.backgroundMainColor
            }
          }),
          blocks: [
            //upstream message
            {
              type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
              style: {
                width: minimumUpstreamMessageWidth,
                height: previewSectionSizes['5xl'],
                marginTop: previewSectionSizes.sm,
                marginBottom: previewSectionSizes['6xl'],
                marginLeft: previewSectionSizes.xs,
                backgroundColor: darkMode
                  ? PreviewThemeColors.dark.backgroundAlternateColor
                  : PreviewThemeColors.light.backgroundMainColor
              }
            }
          ]
        },
        getMobilePreviewButton({ darkMode, message: 'preview.addToCart' })
      ]
    };
  }
};
